"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormElementWrapper = _interopRequireDefault(require("./FormElementWrapper"));

var _excluded = ["hasPasswordViewPermission", "clearable", "type", "value", "defaultValue", "label", "input", "meta", "liveSaver", "tooltip", "onChange", "onBlur", "plain", "onPressEnter"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var inputIcon = {
  text: 'icon-eye-slash',
  password: 'icon-eye'
};

var Input = function Input(props) {
  var hasPasswordViewPermission = props.hasPasswordViewPermission,
      clearable = props.clearable,
      type = props.type,
      value = props.value,
      defaultValue = props.defaultValue,
      label = props.label,
      input = props.input,
      meta = props.meta,
      liveSaver = props.liveSaver,
      tooltip = props.tooltip,
      onChange = props.onChange,
      onBlur = props.onBlur,
      plain = props.plain,
      onPressEnter = props.onPressEnter,
      restProps = _objectWithoutProperties(props, _excluded);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      cursorPosition = _useState2[0],
      setCursorPosition = _useState2[1];

  var _useState3 = (0, _react.useState)(type === 'password' && hasPasswordViewPermission),
      _useState4 = _slicedToArray(_useState3, 1),
      hasToggleIcon = _useState4[0];

  var _useState5 = (0, _react.useState)(type || 'text'),
      _useState6 = _slicedToArray(_useState5, 2),
      inputType = _useState6[0],
      setInputType = _useState6[1];

  var _useState7 = (0, _react.useState)(value || defaultValue || input && input.value || ''),
      _useState8 = _slicedToArray(_useState7, 2),
      inputValue = _useState8[0],
      setInputValue = _useState8[1];

  var _useState9 = (0, _react.useState)(!plain),
      _useState10 = _slicedToArray(_useState9, 2),
      isEditable = _useState10[0],
      setIsEditable = _useState10[1]; // if plain is not provided => !play === true, so by default isEditable


  var _useState11 = (0, _react.useState)(true),
      _useState12 = _slicedToArray(_useState11, 2),
      blurAction = _useState12[0],
      setBlurAction = _useState12[1];

  var inputRef = (0, _react.useRef)(null);

  var handleIconsEnter = function handleIconsEnter() {
    return setBlurAction(false);
  };

  var handleIconsLeave = function handleIconsLeave() {
    return setBlurAction(true);
  };

  var getInputIcons = function getInputIcons() {
    if (!inputValue) return null;
    var icons = [getResetIcon(), getPasswordToggle()].filter(function (item) {
      return !!item;
    });
    if (!icons.length) return null;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "input-field-icons icons-count-".concat(icons.length),
      onMouseEnter: handleIconsEnter,
      onMouseLeave: handleIconsLeave
    }, icons.map(function (item) {
      return item;
    }));
  };

  var getPasswordToggle = function getPasswordToggle() {
    var icon = /*#__PURE__*/_react["default"].createElement("i", {
      key: "icon-password",
      onClick: toggleInputType,
      className: "input-field-icon ".concat(inputIcon[inputType])
    });

    return hasToggleIcon ? icon : null;
  };

  var getResetIcon = function getResetIcon() {
    var clear = /*#__PURE__*/_react["default"].createElement("i", {
      key: "icon-clear",
      onClick: clearValue,
      className: "icon-close"
    });

    return clearable && !plain && !restProps.disabled ? clear : null;
  };

  var toggleInputType = function toggleInputType(ev) {
    ev.preventDefault();
    setInputType(inputType === 'password' ? 'text' : 'password');
  };

  var clearValue = function clearValue() {
    setBlurAction(true);
    setInputValue('');
    setCursorPosition(0);
    if (input && input.onBlur) input.onBlur('');
    inputRef && inputRef.current && inputRef.current.focus();
    if (onChange) onChange('');
  };

  var handleChange = function handleChange(ev) {
    var val = ev.target.value;
    setInputValue(val);
    setCursorPosition(inputRef.current.selectionStart);
    if (input && input.onChange) input.onChange(val);
    if (onChange) onChange(val);
  };

  var toggleEditing = function toggleEditing() {
    return plain && !restProps.disabled && setIsEditable(!isEditable);
  };

  var handleBlur = function handleBlur() {
    if (onBlur) onBlur(inputValue);
    if (input && input.onBlur) input.onBlur(inputValue);
    setCursorPosition(null);
    toggleEditing();
  };

  var handleKeyUp = function handleKeyUp(e) {
    if (e.keyCode === 13) {
      onPressEnter && onPressEnter();
    }
  };

  (0, _react.useEffect)(function () {
    isEditable && plain && inputRef.current.focus();
  }, [isEditable]); // used for value update from LiveSaver cancel

  (0, _react.useEffect)(function () {
    if (input && inputValue !== input.value) {
      setInputValue(input.value);
    }
  }, [input]);
  (0, _react.useEffect)(function () {
    if (inputRef && inputRef.current) {
      if (cursorPosition !== null) {
        inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
      }
    }
  });
  return /*#__PURE__*/_react["default"].createElement(_FormElementWrapper["default"], {
    tooltip: tooltip,
    meta: meta,
    label: label,
    liveSaver: liveSaver,
    blurAction: blurAction,
    required: restProps.required
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-field-wrap ".concat(plain && 'plain' || '')
  }, isEditable && getInputIcons(), isEditable ? /*#__PURE__*/_react["default"].createElement("input", _extends({
    className: "input-field"
  }, input, restProps, {
    value: inputValue,
    ref: inputRef,
    type: inputType,
    onChange: handleChange,
    onBlur: handleBlur,
    onKeyUp: handleKeyUp
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-plain-value ".concat(restProps.disabled ? 'disabled' : ''),
    title: restProps.title,
    onClick: toggleEditing
  }, inputValue ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "value"
  }, inputValue) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "value-placeholder"
  }, restProps.placeholder), !restProps.disabled && /*#__PURE__*/_react["default"].createElement("i", {
    key: "icon-edit",
    className: "input-field-icon icon-edit"
  }))));
};

Input.displayName = 'Input';
Input.propTypes = {
  hasPasswordViewPermission: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  clearable: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  liveSaver: _propTypes["default"].object,
  input: _propTypes["default"].object,
  value: _propTypes["default"].string,
  defaultValue: _propTypes["default"].string,
  label: _propTypes["default"].string,
  meta: _propTypes["default"].object,
  onChange: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  plain: _propTypes["default"].bool
};
Input.defaultProps = {
  hasPasswordViewPermission: false,
  clearable: false,
  required: false
};
var _default = Input;
exports["default"] = _default;